import { useMemo, memo } from 'react'
import { Status } from '../../../../modules/cppoResellerAgreement/reducer'
import { CPPOAgreementStatusTypes } from '../../../../modules/cppoResellerAgreement/actions'
import { useStyles } from './StatusChip.styles'
import clsx from 'clsx'

export const StatusChip = memo(({ status }: { status: Status }) => {
  const { classes } = useStyles()
  const statusClass = useMemo(() => {
    switch (status) {
      case CPPOAgreementStatusTypes.COMPLETED: {
        return 'completed'
      }
      case CPPOAgreementStatusTypes.IN_PROGRESS: {
        return 'active'
      }
      case CPPOAgreementStatusTypes.ACTIVE: {
        return 'active'
      }
      case CPPOAgreementStatusTypes.EXPIRED: {
        return 'expired'
      }
      case CPPOAgreementStatusTypes.RESTRICTED: {
        return 'restricted'
      }
      default:
        return 'restricted'
    }
  }, [status])
  return <div className={clsx(classes.root, statusClass)}>{statusClass}</div>
})
